import { render } from "./StockBarangWr.vue?vue&type=template&id=676b12c4&scoped=true"
import script from "./StockBarangWr.vue?vue&type=script&lang=js"
export * from "./StockBarangWr.vue?vue&type=script&lang=js"

import "./StockBarangWr.vue?vue&type=style&index=0&id=676b12c4&scoped=true&lang=css"
import "./StockBarangWr.vue?vue&type=style&index=1&id=676b12c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676b12c4"]])

export default __exports__